import axios from "axios";
import {get, post } from "@/http/index.js";
import { USER, REGISTER, MEETING, MEMBER, VOTE} from "@/utils/http.js";

/**
 * 全部字典
 */
export const getDictionary = params => get(MEETING + "/dictionary/items", params,true);

/**
 * 会员类型
 */
export const getDuesList = params => post(MEMBER + "/dues/single", params);

//团体会员类型及会费标准
export const getGroupDues = params => post(MEMBER + "/dues/group", params, true);


//获取批处理字段详细
export const getSchemaDetails = params => post(MEMBER + "/schema/details", params, true);

export const researchProjectSave = params => post(MEMBER + "/researchProject/save", params, true);
export const getResearchProjects = params => post(MEMBER + "/researchProject/contacts", params);
export const winSave = params => post(MEMBER + "/researchProject/winProject/save", params, true);
export const getWinProjects = params => post(MEMBER + "/researchProject/winProject", params);
export const paperProjectSave = params => post(MEMBER + "/researchProject/paperProject/save", params, true);
export const getPaperProjects = params => post(MEMBER + "/researchProject/paperProject", params);
export const workProjectSave = params => post(MEMBER + "/researchProject/workProject/save", params, true);
export const getWorkProjects = params => post(MEMBER + "/researchProject/workProject", params);


//个人会员注册配置
export const getSingleRegisterSetting = params =>
    post(MEMBER + "/schema/single/register", params, true);
//团体会员注册配置
export const getGroupRegisterSetting = params =>
post(MEMBER + "/schema/group/register", params, true);

/**
 * 分会/总会
 */
export const getBranchs = () => post(MEMBER + "/branch/branches");

/**
 * 职称
 */
export const getZhiCheng = params =>
    get(MEMBER + "/dictionary/TITLE", params, true);

export const getDictionaryByCode = params =>
    get(MEETING + "/dictionary/" + params);
/**
 * 地址
 */
export const getDivisionData = params => get(MEETING + "/district", params,true);

/**
 * 用户信息
 */
export const getUser = params => get(MEMBER + "/account/current");
// 签到

export const registerSignMeeting = (params) =>
    post(MEETING + "/admin/register/userEnd/signMeeting" , params);

//当前登录用户
export const getCurrentAccount = params => get(MEMBER + "/account/current", params);

//全部会议
export const getMeetingAll = (params, page) =>
    post(MEETING + "/page/" + page, params);
export const getMeetingPageAll = (params, page) =>
    post(MEETING + "/meetingPage/" + page, params);
//正在报名的会议
export const getStartingMeeting = (params, page) =>
    post(MEETING + "/starting/" + page, params);
//未开始会议
export const getNotstarted = (params, page) =>
    post(MEETING + "/notstarted/" + page, params);
//已结束会议
export const getFinished = (params, page) =>
    post(MEETING + "/finished/" + page, params);
//个人会员注册会议
export const singleRegister = (params) =>
    post(MEETING+ "/single/register", params,true);
//获取地址
export const getAddress = params => get(MEETING + "/district");
//缴费凭证图片
export const getPZUrl = params => get(MEMBER + "/file/display/base64", params);
//获取用户信息
export const getAssociationCurrent = params =>
    post(MEMBER + "/association/current");
//注册审核信息
export const getAuditInfo = params =>
    post(MEMBER + "/account/audit/info", params);
//会员缴费配置
export const getMemberConfig = params =>
    post(MEMBER + "/lin/register/getMemberConfig", params,true);

//已报名会议
export const registeredMeeting = (params, page) => post(MEETING + "/register/page/" + page, params, true);
//未缴费列表
export const getMeetingPaymentList = (params, page) => post(MEETING + "/order/page/" + page, params);
// 获取会议注册设定
export const getMeetingSettings = params => get(MEETING + "/register/setting", params, true);
// 获取会议注册默认表单值
export const getRegisterForm = params => post(MEETING + "/register/form", params);
// 会议报名
export const registerMeeting = params => post(MEETING + "/register", params, true);
// 会议报名时根据姓名和手机号查询用户信息
export const getUserInfoByNameMobile = params => post(MEETING + "/register/findUser", params, true);
//会议报名时的用户快速注册
export const registerUser = params => post(MEMBER + "/register/userAndMember", params, true);
//会议宾馆
export const getHotels = params => post(MEETING + "/hotel/hotels", params, true);
//宾馆信息保存
export const hotelSave = params => post(MEETING + "/hotel/booking", params, true);
//base64
export const getBase64 = params => get(MEETING + "/file/display/base64", params, true);

//base64
export const getBase64htp = MEETING + "/file/display/base64";
// 获取已报名会议
export const getRegisterList = params => post(MEETING + "/register/list", params);
//创建会议订单
export const createMeetingOrder = params => post(MEETING + "/order/create", params || {});
//所属专题列表
export const paperTopics = params =>
    post(MEETING + "/admin/paperTopic/paperTopics", params, true);
//论文删除
export const paperFileDelete = params =>
    post(MEETING + "/paper/file/delete", params, true);
//论文投递
export const paperSubmit = params =>
    post(MEETING + "/paper/submit", params, true);
//重新提交论文
export const againCommitPaper = params =>
    post(MEETING + "/paper/againCommitPaper", params, true);
//域名
export const baseURL = axios.defaults.baseURL;

//缴费历史记录
export const getPaymentList = (params, page) =>
    post(MEMBER + "/order/page/" + page, params);
//取消记录
export const paymentCancel = params => post(MEMBER + "/order/cancel", params);
//取消订单
export const cancelMeetingOrder = params =>
    post(MEETING + "/order/cancel", params || {});


//会员缴费审核
export const memberAudit = params =>
    post(MEMBER + "/admin/order/audit", params);
//是否显示缴纳会费按钮
export const isShowPayBtn = params =>
    post(MEMBER + "/order/create/check", params);
//创建订单
export const createOrder = params => post(MEMBER + "/order/create", params);
//支付宝支付
export const getAliCode = params => post("/alipay/membership/pay", params);
//微信支付-会员
export const getWXCode = params => post(MEMBER + "/wxpay/pay", params);
//赢商通支付-会员
export const getYSTCode = params => post(MEMBER + "/yst/jsPay", params);
//微信支付-链接
export const getAuthurl = params => post(MEMBER + "/wxpay/getAuthurl", params);
//微信支付-链接
export const getOpenid = params => post(MEMBER + "/wxpay/getOpenid", params);

//订单详情
export const getOrderDetails = params => get(MEMBER + "/order/details", params);
//微信支付-会议
export const getMeetingWXCode = params => post(MEETING + "/wxpay/pay", params);
//是否支持微信支付-会员
export const getWXPay = params => post(MEMBER + "/config/wxpay/enable", params);
//是否支持微信支付-会议
export const getMeetingWXPay = params =>
    post(MEETING + "/config/wxpay/enable", params);
//线下提交
export const underLineSubmit = params => post(MEMBER + "/offline/pay", params);
//支付凭证
export const underLineSubmita = params => post(MEMBER + "/offline/pay/file", params);
//支付SockJS-会员
export const SockJSURL = MEMBER + "/websocket";
//支付SockJS-会议
export const SockJSMeetingURL = MEETING + "/websocket";

//退出
export const logout = params => post(USER + "/oauth/logout", params);

//会议详情
export const getMeetingDetail = params =>
    post(MEETING + "/details", params, true);

//会议报名会费标准
export const getHotelsDues = params =>
    post(MEETING + "/register/getDues", params, true);

export const groupRegister = (params) =>
        post(MEETING+ "/group/register", params);
     
//单位报名  == 查询已经添加过的人员
export const getGroupRegisterMember = params => post(MEETING + "/group/getGroupRegisterMember", params,true);
//单位报名  == 暂存个人报名信息
export const groupMeetingRegisterMember = params => post(MEETING + "/group/registerMember", params,true);
//获取上次登录信息
export const getLastLoginTime = params =>
    post(MEMBER + "/account/user", params);

// 获取会议会场
export const getMeetingPlaces = params =>
    post(MEETING + "/place/places", params, true);


//未缴费列表 --- 团体会员
export const getGroupMeetingPaymentList = (params, page) =>
    post(MEETING + "/order/group/page/" + page, params);
/**
 * 站内信
 */
//获取站内信消息
export const queryMail = (params, page) =>
    post(MEMBER + "/info/queryMail/" + page, params);
//删除站内信消息
export const delMessageReceiver = (params) =>
    post(MEMBER + "/info/delMessageReceiver", params);
//保存收件信息
export const saveReceiver = (params) =>
    post(MEMBER + "/info/saveReceiver", params);
//站内信已读条数
export const unRead = (memberId) =>
    get(MEMBER + "/info/unRead", memberId);
//站内信详情
export const findInfoById = (params) =>
    get(MEMBER + "/info/findInfoById", params);
//站内信详情
export const findFileById = (params) =>
    get(MEMBER + "/file/findFileById", params);
//检查站内信是否有未插入消息
export const getCheckMessage = params =>
    get(MEMBER + "/info/checkMessageInfo", params, true);
//下载
export const downLoadFile = id => MEETING + "/file/download?id=" + id;
//单个论文下载
export const getPaperDownload = id =>MEETING +"/admin/paper/download/paper?id=" +id;
//会员风采列表
export const getMemberStyleList = (params, page) => get(MEMBER + "/admin/memberStyle/page/" + page, params);
//会员风采详情
export const MemberStyleDetails = params => get(MEMBER + "/admin/memberStyle/details", params);
//会员风采保存
export const saveMemberStyle = params => post(MEMBER + "/admin/memberStyle/save", params);
//资源共享列表
export const getResource = (params, page) => post(MEMBER + "/resource/sharing/page/" + page, params);
//pdf流
export const showPdf = MEMBER + "/resource/sharing/showPdf?enclosureId=";

//用户反馈提交
export const saveFeedBack = params =>
    post(MEMBER + "/feedBack/save", params, true);

/**
 * 通知公告
 */
//获取列表
export const noticeList = (params, page) => post(MEMBER + "/notice/page/" + page, params);
//获取通知（单条）
export const getNotice = params => get(MEMBER + "/notice/getNotice/", params);
//获取会员信息
export const getMemberInfo = params => get(MEMBER + "/member/getMemberInfo/", params);
//获取资源共享列表
export const getResourceList = (params, page) => post(MEMBER + "/mresource/getResourceList/" + page, params);
//获取共享资源
export const getResourceFile = params => post(MEMBER + "/mresource/getResourceFile", params);

/**
 * 发票
 */
//获取订单信息
export const getOrderInfo = (params, page) => post(MEMBER + "/order/page/" + page, params);
//申请开票
export const applyInvoice = params => post(MEMBER + "/order/invoice/apply", params);

/**
 * 会议论文接口
 */
//列表
export const getPapers = (params, page) =>
    post(MEETING + "/paper/papers/" + page, params);
//删除
export const delPaper = params => post(MEETING + "/paper/delete", params, true);

//会议报名 -- 流程版
export const registerHydro = (params) =>
    post(MEETING + "/hrdro/register", params);
//会议注册步骤
export const updateRegisterStep = (params) =>
    post(MEETING + "/update/registerStep", params);
//查询会议报名信息
export const getRegisterInfo = (params) =>
    post(MEETING + "/register/info", params);
//会议更新
export const registerMeetingUpdate = params =>
    post(MEETING + "/register/update", params, true);
//关注分会职务列表
export const getMemberPost = params =>
    get(MEMBER + '/admin/branch/memberPostList', params)
//会议活动报名
export const meetingRegisterNoLogin = params =>
    post(MEETING + '/meetingRegister/noLogin', params)
// 【地震会议】报名
export const signeGroupRegister = params =>
    post(MEETING + '/meetingRegister', params)
// 会议报名信息查询
export const getRegisterMeetingDetail = params =>
    post(MEETING + "/register/getRegisterMeetingDetail", params, true);

//获取投票列表
export const getElectionReleasePage = (params, page) =>
    post(MEMBER + "/admin/voteElection/electionRelease/" + page, params);

//获取一条投票信息
export const getElectionReleaseInfo = params =>
    get(MEMBER + '/admin/voteElection/getElectionReleaseInfo', params,true)

//获取投票内容列表
export const getCandidateList = params =>
    get(MEMBER + '/admin/voteElection/candidate/candidateList', params)

//真实投票
export const voteInfoSave = params =>
    post(MEMBER + '/admin/voteElection/voteInfo/save', params)

//根据姓名手机查询指定人
export const getElectionVote = params =>
    post(MEMBER + '/admin/voteElection/electionVote/getElectionVote', params)

//查询投票次数
export const voteInfoTimes = params =>
    post(MEMBER + '/admin/voteElection/voteInfo/times', params)

//单位 暂存
export const saveGroupMemberSz = params =>
    post(MEMBER + "/admin/group/save/shizheng", params,true);

    
//个人 暂存
export const saveMembers = params =>
    post(MEMBER + "/admin/single/saveMember", params,true);

// 获取分享设置
export const memberShareGet = params =>
    post(MEMBER+ "/admin/memberShare/get/share/setting", params);


export const invitationRecordPage = (params, page) =>
    post(MEMBER + "/invitationRecord/detail/page/" + page, params);
 
// 获取VOTE微信配置
export const getVoteWxConfig = params =>
    post(VOTE + "/getWxconfig", params);
// 判断是否可以创建订单
export const canCreateOrder = (params) =>
    post(MEMBER + "/order/canCreateOrder" , params);
//上传
export const uploadURL = MEMBER + "/file/upload";
// 判断是否可升级
export const singleCanUpgrade = (params) =>
    post(MEMBER + "/upGrade/canUpGrade" , params);

// 申请延长有效期
export const applyReduction = (params) =>
    post(MEMBER + "/apply/reduction" , params);
// 延长有效期列表
export const applyReductionPage = (params, page) =>
   post(MEMBER + "/apply/reduction/page/" + page, params);
// 是否允许延长有效期
export const applySubmit = (params) =>
   post(MEMBER + "/apply/repeat/submit" , params);
// 个人会员】申请会员类型变更
export const upGradeSingleApply = (params) =>
   post(MEMBER + "/upGrade/single/apply" , params);
 
// 个人会员类型变更列表
export const upGradePage = (params, page) =>
   post(MEMBER + "/upGrade/page/" + page, params);
// 获取变更信息
export const upGradeDetail = (params) =>
   post(MEMBER + "/upGrade/detail" , params);
//查询订单结果信息
export const meetingOrderDetails = params =>
   post(MEETING + "/admin/order/wx/order/details", params, true);
//查询订单结果信息
export const meetingorderChangeDetails = params =>
   post(MEETING + "/admin/order/wx/orderChange/details", params, true);
//微信支付-链接
export const getAuthurlMeeting = params => post(MEETING + "/wxpay/getAuthurlmeeting", params);
//会议缴费
export const underLineSubmitMeeting = params => post(MEETING + "/order/pays", params)
// 会议列表
export const registerPage = (params, page) =>
   post(MEETING + "/register/page/" + page, params);
// 取消报名
export const cancelRegister = params => post(MEETING + "/cancelRegister", params)
// 报名详情
export const meetingRegisterDetails = params => post(MEETING + "/meetingRegister/details", params)
// 修改报名信息 
export const updateMeetingRegister = params => post(MEETING + "/update/meetingRegister", params)
// 验证是否已经报名 
export const checkRegister = params => post(MEETING + "/check/register", params)
// 获取聘任列表
export const memberPage = (params, page) =>
   post(MEMBER + "/admin/branchAppointment/memberPage/" + page, params);
// 预览证书
export const previewCertificate = (params) =>
   post(MEMBER + "/admin/branchAppointment/previewCertificate", params);  
//获取国籍
export const getNationality = params => get(USER + "/nationality", params,true);
//获取文件详情
export const getFileIdDetails = (params) =>
    get(MEMBER + "/file/findFileById", params, true);

 export const printingSeal = (params) => get(MEMBER+ "/admin/group/printingSeal", params,true);

//保存打印id
export const saveSingleSeal = (params) => get(MEMBER+ "/admin/single/saveSingleSeal", params,true);

export const registerFileDelete = params =>
    post(MEMBER + "/file/delete", params, true);

//打印个人会员信息材料
export const printSingleSeal = MEMBER + "/admin/single/printSingleSeal";
//发票记录
export const memberInvoice = params =>
    get(MEETING + "/memberInvoice/list", params, true);
//申请会议发票
export const fillnvoicelnfo = params =>
    post(MEETING + "/order/fillInvoiceInfo", params, true);
//查询会议订单发票信息
export const getMeetingInvoiceInfo = params =>
    post(MEETING + "/order/invoice/details", params, true);
